export class ProfileTypeModel {
  type: string;
  display: string;
  class: string;
  classForegroundOnly: string;
  classBackgroundOnly: string;
  icon: string;
}
